var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-height":"700px","overflow":"auto"}},[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-error":_vm.onDropzoneError,"vdropzone-success":_vm.onDropzoneSuccess,"vdropzone-removed-file":_vm.onDropzoneRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }